import { observer } from "mobx-react-lite";
import { useCallback, useEffect, useState } from "react";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
import { H5SubPageShell } from "../../components/common/H5SubPageShell";
import "../../components/common/H5SubPageShell.css";
import { MyBenefitsApi } from "../../customer_account/MyBenefitsApi";
import type { AppMyBenefitRow } from "../../customer_account/MyBenefitsType";
import { formatApiDate } from "../../utils/Backend";
import { useRequireLoginRedirect } from "../../utils/useRequireLoginRedirect";

function formatProductLabel(row: AppMyBenefitRow): string {
  const sub = row.subProductName?.trim();
  if (sub) {
    return `${row.productName} · ${sub}`;
  }
  return row.productName;
}

export const SpaceMineBenefitsPage = observer(() => {
  const { spaceId } = useParams<{ spaceId: string }>();
  const canView = useRequireLoginRedirect();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<AppMyBenefitRow[]>([]);

  const load = useCallback(async () => {
    if (!canView) {
      return;
    }
    setLoading(true);
    const res = await MyBenefitsApi.listMyBenefits({});
    setLoading(false);
    if (typeof res === "string") {
      return;
    }
    setRows(res.list ?? []);
  }, [canView]);

  useEffect(() => {
    void load();
  }, [load]);

  const backTo = spaceId ? `/space/${spaceId}/mine` : undefined;

  return (
    <H5SubPageShell title="我的权益" backTo={backTo}>
      <Spin spinning={loading}>
        {!loading && rows.length === 0 ? (
          <p className="h5-sub-page__empty">暂无权益记录</p>
        ) : (
          <ul className="h5-sub-page__list">
            {rows.map((row) => (
              <li
                key={`${row.spaceId}-${row.spaceProductId}-${row.subProductName || "default"}`}
                className="h5-sub-page__list-item"
              >
                <p className="h5-sub-page__list-item-title">{formatProductLabel(row)}</p>
                <p className="h5-sub-page__list-item-meta">
                  {formatApiDate(row.benefitStartAt) || "—"} 至 {formatApiDate(row.benefitEndAt) || "—"}
                </p>
              </li>
            ))}
          </ul>
        )}
      </Spin>
    </H5SubPageShell>
  );
});

export default SpaceMineBenefitsPage;
